import { PropsWithChildren } from 'react';

import css from './styles.module.css';

/**
 * Trailing content, aligned to the right of the notice body.
 */
export function NoticeActions({ children }: PropsWithChildren) {
  return <span className={css.actions}>{children}</span>;
}
